import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { fwHttpClientUtils } from '@myapp/modules/fwcore/models';
import { RequestDelete, ResponseDelete } from '@myapp/modules/fwcore/models/messages';
import { BaseHttpReqRespService, BaseHttpService } from '@myapp/modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import urlJoin from 'url-join';
import { IInstanceConfiguration } from '../../admin/models/future-deprecation/IInstanceConfiguration'
import { ICompany, IUser, License, Module } from '../models';
@Injectable({
  providedIn: 'root'
})
export class InstanceConfigurationService extends BaseHttpReqRespService {

  /*-------------------------- Internal properties  ---------------------------*/

  readonly instanceEndpoint: string = 'instanceconfiguration';
  readonly instanceByNameEndpoint: string = 'instanceconfiguration/GetConfigurationByName';
  readonly upsertInstanceConfiguration: string = 'instanceconfiguration/UpsertInstanceConfiguration';


  constructor(http: HttpClient
    , @Inject(OKTA_AUTH) protected auth: OktaAuth
    , @Inject('CONFIG_SETTINGS') private config: any) {

    super(http, auth);

    const configSettings = config['general'];
    this.baseUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];
  }

  /*-------------------------- public properties / methods --------------------*/

  getInstanceConfigurationByName(clientName: string): Observable<IInstanceConfiguration> {

    var emptyObj: IInstanceConfiguration = {
      id: '',
      clientName: '',
      oktaClientId: '',
      gxURL: '',
      gxKey: '',
      gxPassword: ''
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    })
    const url = urlJoin(this.baseUrl, this.instanceByNameEndpoint + '/' + clientName);
    try {
      return this.getItem<IInstanceConfiguration>(url, headers);
    } catch (e) {
      return of(emptyObj);
    }

  }


  getAlInstanceConfiguration(): Observable<IInstanceConfiguration[]> {
    var token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.instanceEndpoint);
      try {
        return this.getItems<IInstanceConfiguration>(url, this.getHttpBearerHeaders(token));
      } catch (e) {
        var emptyUsers: IInstanceConfiguration[] = [];
        return of(emptyUsers);
      }
    }
    else {
      var emptyUsers: IInstanceConfiguration[] = [];
      return of(emptyUsers);
    }
  }

  upsertInstanceConfigurationItem(objIInstanceConfiguration: IInstanceConfiguration,isNew:boolean): Observable<boolean> {
    var token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.upsertInstanceConfiguration);
      try {
        return this.saveItem(objIInstanceConfiguration, isNew, url, this.getHttpBearerHeaders(token));
       
      } catch (e) {
       
        return of(false);
      }
    }
    else {
      
      return of(false);
    }
  }
  deleteInstanceConfigurationItem(objIInstanceConfiguration: IInstanceConfiguration): Observable<boolean> {
    var token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.baseUrl, this.instanceEndpoint + '/' + objIInstanceConfiguration.id.toString());
      try {
        return this.removeItem(objIInstanceConfiguration, url, this.getHttpBearerHeaders(token));

      } catch (e) {

        return of(false);
      }
    }
    else {

      return of(false);
    }
  }
  
}

